/**
 * Colour wardrobe (homepage). Each [data-colour-arch] jharokha shows one colour of a product.
 * - [data-colour-dot]: swaps the front photo (and the back layer, when that colour has a back),
 *   marks the disc active, and retargets the arch link to that colour's variant.
 * - [data-arch-turn]: on touch screens, turns the arch to its back and front again. On desktop
 *   the back also fades in on hover via the shared .flip-back rule in config/styles.css.
 * All URLs and IDs are server-rendered; no network requests. Crossfade skipped with reduced motion.
 */
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

function setTurned(arch, turned) {
  const turn = arch.querySelector('[data-arch-turn]');
  arch.toggleAttribute('data-show-back', turned);
  if (!turn) return;
  turn.setAttribute('aria-pressed', String(turned));
  turn.textContent = turned ? turn.dataset.labelFront : turn.dataset.labelBack;
}

function choose(dot) {
  const arch = dot.closest('[data-colour-arch]');
  const photo = arch?.querySelector('[data-arch-photo]');
  const link = arch?.querySelector('[data-arch-link]');
  if (!photo || !link) return;

  for (const other of arch.querySelectorAll('[data-colour-dot]')) {
    other.setAttribute('aria-pressed', String(other === dot));
  }

  const back = arch.querySelector('[data-arch-back]');
  const turn = arch.querySelector('[data-arch-turn]');
  const hasBack = Boolean(dot.dataset.backSrc);

  const apply = () => {
    photo.src = dot.dataset.src;
    photo.srcset = dot.dataset.srcset;
    photo.alt = photo.alt.replace(/ — .+$/, ` — ${dot.dataset.colourName}`);
    if (back) {
      back.hidden = !hasBack;
      if (hasBack) {
        back.src = dot.dataset.backSrc;
        back.srcset = dot.dataset.backSrcset;
      }
    }
    photo.classList.remove('opacity-0');
  };

  const colourLabel = arch.querySelector('[data-arch-colour]');
  if (colourLabel) colourLabel.textContent = dot.dataset.colourName;

  if (turn) turn.hidden = !hasBack;
  if (!hasBack) setTurned(arch, false);

  if (reduceMotion.matches) {
    apply();
  } else {
    photo.classList.add('transition-opacity', 'duration-300', 'opacity-0');
    setTimeout(apply, 200);
  }

  const base = arch.dataset.productUrl;
  if (base) link.href = `${base}?variant=${dot.dataset.variantId}`;
}

document.addEventListener('click', (event) => {
  const dot = event.target.closest?.('[data-colour-dot]');
  if (dot) return choose(dot);
  const turn = event.target.closest?.('[data-arch-turn]');
  if (turn) {
    const arch = turn.closest('[data-colour-arch]');
    if (arch) setTurned(arch, !arch.hasAttribute('data-show-back'));
  }
});
